import { buildUrlForAddUniqueQueryParam } from '../updateQueryString';
import qs from '../qs';

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const getFormattedDateFromIsoDate = isoDate => {
  const localDate = new Date(isoDate);
  // Format parts
  const day = localDate.getDate();
  const month = localDate.toLocaleString('en-GB', { month: 'long' });

  const getOrdinal = n => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;

    return s[(v - 20) % 10] || s[v] || s[0];
  };

  const formatted = `${day}${getOrdinal(day)} ${month}`;

  return formatted;
};

export const iconTypesForLatestUploads = {
  campaign: '/assets/images/icons/campaign_icon.svg',
  image: '/assets/images/icons/gallery_icon.svg',
  video: '/assets/images/icons/video_icon.svg',
  playlist: '/assets/images/icons/table_icon.svg',
  folder: '/assets/images/icons/folder_icon.svg',
  schedule: '/assets/images/icons/schedule_icon.svg',
  sign: '/assets/images/icons/sign_icon.svg',
  assignment: '/assets/images/icons/assignment_icon.svg',
  dfs: '/assets/images/icons/dfs.svg',
  sequence: '/assets/images/icons/sequence.svg',
};

export function getFolderUrl(item, props) {
  const { location } = props;
  const sub = (qs(props).parent || '').endsWith('*') ? '*' : '';
  const parent = `${item.parent + item.name}/${sub}`;

  return buildUrlForAddUniqueQueryParam(location, 'parent', parent);
}
